







































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import SepSvc from "@/services/bridgingVclaim/SEP";
import { appModule } from "@/store/modules/app";

@Component({})
export default class PengajuanSepModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly noKartu!: string;

  tglSep = "";
  jnsPelayanan = "";
  jnsPengajuan = "";
  keterangan = "";
  user = "user ws";

  saving = false;
  showTglSep = false;
  jnsPelayananOpts = [
    { text: "Rawat Inap", value: "1" },
    { text: "Rawat Jalan", value: "2" },
  ];
  jnsPengajuanOpts = [
    { text: "Pengajuan Backdate", value: "1" },
    { text: "Pengajuan Fingerprint", value: "2" },
  ];

  clearForm() {
    this.tglSep = "";
    this.jnsPelayanan = "";
    this.jnsPengajuan = "";
    this.keterangan = "";
  }

  get reqData() {
    return {
      noKartu: this.noKartu,
      tglSep: this.tglSep,
      jnsPelayanan: this.jnsPelayanan,
      jnsPengajuan: this.jnsPengajuan,
      keterangan: this.keterangan,
      user: this.user,
    };
  }

  save() {
    if (!this.saving) {
      SepSvc.pengajuan(this.reqData)
        .then((resp) => {
          if (resp.status == 1) {
            appModule.NoticeDelay("Berhasil Membuat Pengajuan");
            alert("Berhasil Membuat Pengajuan");

            this.close();
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .catch((resp) => {
          appModule.sendErrorAlert(resp.message);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");

    this.clearForm();
  }

  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD MMMM YYYY") : "";
  }
}
